import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { AnalyticsEventRow } from "@/hooks/useAnalyticsConversao";

interface Props {
  events: AnalyticsEventRow[];
}

const MetricsCards: React.FC<Props> = ({ events }) => {
  const count = (fn: (e: AnalyticsEventRow) => boolean) => events.filter(fn).length;

  const totalVisits = count((e) => e.event_type === "page_view");
  const homeVisits = count((e) => e.event_type === "page_view" && e.path === "/");
  const pagVisits = count((e) => e.event_type === "page_view" && e.path === "/pagamento");
  const planosVisits = count((e) => e.event_type === "page_view" && e.path === "/planos");
  const nubankClicks = count((e) => e.event_type === "direct_payment_nubank_click");
  const whatsAll = count((e) => e.event_type === "whatsapp_click" || e.event_type === "direct_payment_whatsapp_click");
  const stripeClicks = count(
    (e) => e.event_type === "checkout_click" && (e.metadata?.origin === "planos_stripe")
  );
  const signupStarted = count((e) => e.event_type === "signup_started");
  const signupCompleted = count((e) => e.event_type === "signup_completed");
  const logins = count((e) => e.event_type === "login");

  const mobile = count((e) => e.device === "mobile");
  const desktop = count((e) => e.device === "desktop");
  const totalDev = mobile + desktop;
  const mobilePct = totalDev ? Math.round((mobile / totalDev) * 100) : 0;
  const desktopPct = totalDev ? 100 - mobilePct : 0;

  const items = [
    { label: "Total de visitas", value: totalVisits },
    { label: "Visitas / (home)", value: homeVisits },
    { label: "Visitas /pagamento", value: pagVisits },
    { label: "Visitas /planos", value: planosVisits },
    { label: "Cliques Nubank", value: nubankClicks },
    { label: "Cliques WhatsApp", value: whatsAll },
    { label: "Cliques Stripe", value: stripeClicks },
    { label: "Cadastros iniciados", value: signupStarted },
    { label: "Cadastros concluídos", value: signupCompleted },
    { label: "Logins", value: logins },
    { label: "Mobile %", value: `${mobilePct}%` },
    { label: "Desktop %", value: `${desktopPct}%` },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
      {items.map((it) => (
        <Card key={it.label}>
          <CardContent className="p-4">
            <div className="text-xs text-muted-foreground">{it.label}</div>
            <div className="text-2xl font-bold mt-1">{it.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default MetricsCards;
